// 检查是否是小数
const checkDeci = (num, precision = 6) => {
  if (isNaN(num)) {
    return '';
  }
  if (num % 1 === 0) {
    return num.toString();
  }
  return num.toFixed(precision);
};

// 获取querystring 中的参数的值
const getQueryParam = (query, field) => {
  let reg = new RegExp('(^|&)' + field + '=([^&]*)(&|$)', 'i');
  let r = query.match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
};
// 获取url中的查询参数
const getUrlStringQueryParam = (url, field) => {
  let query = url.split('?')[1];
  if (query) {
    return getQueryParam(query, field);
  }
};

const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export { checkDeci, getUrlStringQueryParam, isMobile };
